/**
 * PostHog feature-flag keys for mobile.
 *
 * These constants are the single source of truth for the flag keys. Call sites must
 * import from here instead of hardcoding the string keys, so the code and the PostHog
 * dashboard can never drift apart.
 *
 * Empty right now — DEV-1131 removed the last of the original flags once they had all
 * reached 100% rollout. The module is kept deliberately: it is the registry the next
 * flag gets added to, alongside {@link useFeatureFlagsLoaded} (the anti-flash gate) and
 * `e2eFeatureFlagOverrides` (the e2e bootstrap hook). Do not delete it as dead code.
 *
 * To add a flag: create it in PostHog first (disabled in every environment), then export
 * its key here and read it with `useFeatureFlagEnabled(FLAG_X) ?? false`.
 */

/**
 * Gates the multi-stem DBH stem editor (TPM-1536).
 *
 * Entitlement is data, not flag: whether a tenant *can* use the calculator is decided by
 * whether the field-config import provisioned stem fields for their asset class. This flag
 * decides only whether the code path is live, so it can be turned off in one PostHog toggle
 * without touching ~577 tenants' field config — un-provisioning them would be a manual
 * re-import campaign.
 *
 * The server-side BS5837 mode-3 guard in TPM-1543 is deliberately NOT flagged: it is a
 * safety net under our own client, and a client flag must never gate a server boundary.
 */
export const FLAG_MULTI_STEM = 'tpm-multi-stem';

/**
 * Gates hiding and disabling what the user's access snapshot denies (IAM, TP3-584), flag
 * `iam.mobile.gating` (TP3-600). PostHog keys can't contain dots, so the key uses hyphens.
 * Off everywhere until launch; target it by `tenant` group or by user.
 *
 * Like FLAG_MULTI_STEM it only changes what the app shows: the server checks every command
 * whatever this flag says.
 */
export const FLAG_IAM_GATING = 'iam-mobile-gating';
